import React from 'react';
import Modal from '../modals/Modal';

const VacationWarningModal = ({
  isOpen,
  adminMode,
  onClose,
  remaining,
  requested,
  t
}) => {
  const handleOk = () => {
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t && t('insufficientVacationDaysTitle') !== 'insufficientVacationDaysTitle' ? t('insufficientVacationDaysTitle') : 'Insufficient Vacation Days'}
      type="warning"
      actions={
        <button
          onClick={handleOk}
          style={{
            backgroundColor: '#f59e0b',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            padding: '10px 20px',
            fontSize: '14px',
            fontWeight: '500',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#d97706'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#f59e0b'}
        >
          {t && t('ok') !== 'ok' ? t('ok') : 'OK'}
        </button>
      }
    >
      <div style={{ fontSize: '16px' }}>
        <p style={{ margin: '0 0 16px 0' }}>
          {(() => {
            const adminKey = 'insufficientVacationDaysMessageAdmin';
            const userKey = 'insufficientVacationDaysMessage';
            const key = adminMode ? adminKey : userKey;
            const defaultMsg = `You are trying to book ${requested} vacation day${requested !== 1 ? 's' : ''}, but you only have ${remaining} day${remaining !== 1 ? 's' : ''} remaining.`;
            if (!t) return defaultMsg;
            const translated = t(key, { remaining, requested });
            return translated !== key ? translated : defaultMsg;
          })()}
        </p>
        <p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
          {t && t('pleaseAdjustSelection') !== 'pleaseAdjustSelection' ?
            t('pleaseAdjustSelection') :
            'Please adjust your selection to fit within your available vacation balance.'}
        </p>
      </div>
    </Modal>
  );
};

export default VacationWarningModal;
